<template>
    <b-container>
        <div class="d-block m-auto text-center pb-4">
            <img width="250px" src="../../assets/img/login2.svg" class="img-fluid">
            <h1 class="text-center mt-4 mb-2">Login</h1>
        </div>
        <b-form v-on:submit.prevent="login">
            <b-alert variant="danger" :show="loginError">
                Unable to login with the provided credentials. Please check your email and password and try again.
            </b-alert>
            <b-form-group label="Email address">
                <b-form-input size="lg" type="email" v-model="email"></b-form-input>
                <b-form-invalid-feedback v-if="errors.email">{{ errors.email[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Password">
                <b-form-input size="lg" type="password" v-model="password"></b-form-input>
                <b-form-invalid-feedback v-if="errors.password">{{ errors.password[0] }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
                <b-button size="lg" variant="primary" block disabled v-if="loading">
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                </b-button>
                <b-button size="lg" type="submit" v-else block variant="primary">Login</b-button>
            </b-form-group>

            <b-form-group>
                <router-link :to="{name: 'forgotPassword'}" class="btn btn-block btn-link">Forgot password?</router-link>
            </b-form-group>
        </b-form>
    </b-container>
</template>

<script>
    import store from './../../store'

    export default {
        name: "loginModal",

        data() {
            return {
                loginError: false,
                loading: false,
                email: '',
                password: '',
                errors: []
            }
        },

        methods: {
            close() {
                this.$bvModal.hide('login-modal')
            },

            login() {
                this.loading = true;
                axios.post('/login', this.$data).then(response => {
                    localStorage.setItem('token', response.data.access_token);
                    store.commit('LOGIN_USER');
                    this.$toasted.show("Successfully logged into your account.");
                    this.loading = false;
                    this.$router.push({name: 'menu_categories'});
                }).catch(error => {
                    this.loading = false;
                    this.loginError = true;
                })
            }
        }
    }
</script>

<style scoped>

</style>